/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Keyword_EmptyInputs */

const en_search_keyword_empty = /** @type {(inputs: Search_Keyword_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No endpoints match that keyword. Try the use-case search above.`)
};

const zh_hans1_search_keyword_empty = /** @type {(inputs: Search_Keyword_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有接口匹配这个关键词。试试上方的使用场景搜索。`)
};

const pt_br2_search_keyword_empty = /** @type {(inputs: Search_Keyword_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum endpoint corresponde a essa palavra-chave. Tente a pesquisa por caso de uso acima.`)
};

const es_search_keyword_empty = /** @type {(inputs: Search_Keyword_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ningún endpoint coincide con esa palabra clave. Prueba la búsqueda por caso de uso de arriba.`)
};

const fr_search_keyword_empty = /** @type {(inputs: Search_Keyword_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun endpoint ne correspond à ce mot-clé. Essayez la recherche par cas d’usage ci-dessus.`)
};

const de_search_keyword_empty = /** @type {(inputs: Search_Keyword_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Endpoint passt zu diesem Keyword. Probier die Anwendungsfall-Suche oben.`)
};

const ru_search_keyword_empty = /** @type {(inputs: Search_Keyword_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ни один эндпоинт не подходит под это слово. Попробуйте поиск по задаче выше.`)
};

const it_search_keyword_empty = /** @type {(inputs: Search_Keyword_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun endpoint corrisponde a quella parola chiave. Prova la ricerca per caso d'uso qui sopra.`)
};

/**
* | output |
* | --- |
* | "No endpoints match that keyword. Try the use-case search above." |
*
* @param {Search_Keyword_EmptyInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const search_keyword_empty = /** @type {((inputs?: Search_Keyword_EmptyInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Keyword_EmptyInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_search_keyword_empty(inputs)
	if (locale === "pt-BR") return pt_br2_search_keyword_empty(inputs)
	if (locale === "es") return es_search_keyword_empty(inputs)
	if (locale === "fr") return fr_search_keyword_empty(inputs)
	if (locale === "de") return de_search_keyword_empty(inputs)
	if (locale === "ru") return ru_search_keyword_empty(inputs)
	if (locale === "it") return it_search_keyword_empty(inputs)
	return en_search_keyword_empty(inputs)
});